/* eslint-disable max-len */

export default {
  lang: "English",
  homeScreen: {
    title: "The Theme Park Capital of the World", // Product specific
    stayConnected: "Stay Connected",
    comingSoon: "Coming Soon",
    messages: "Messages",
  },
  notification: {
    newAndNow: "New & Now!",
    alert: "Alert",
    message: "Message",
    contest: "Contest",
    badge: "New Badge",
    "content-update": "Content Update",
    events: "Events",
  },
  loginScreen: {
    version2: {
      homeTitle:
        "Let's see if we can find an existing profile for you in our system.",
      homeTitleSub:
        "Enter the email address you typically use to login to training programs.",
      noAccount:
        "No account found ({email}), please try with another email or create an account now.",
      continueButton: "Continue",
      success:
        "Successfully updated your account! You will be redirected shortly to the home page.",
      successNewAccount:
        "To complete your registration, you will receive a confirmation email to verify your account.",
      loginButton: "Login",
      matchFound:
        "We have found a match, please fill in your password to continue.",
      magicLink: "Login via a link in your email:",
      magicLinkButton: "Request Magic Link",
      magicLinkTitle:
        "Get a direct link sent to your email that will sign you in instantly.",
      otherEmailButton: "Submit",
      title:
        "Please take a moment to complete all the information below as it will populate your personal profile and contact information.",
      titleIndustry:
        "Please take a moment to complete all the information below as it will populate your personal profile and contact information.",
      register: "Create an account",
      agent: "Travel Advisor",
      visitor: "Industry Visitor",
      step1: "Step 1: Type of User",
      step2: "Step 2: Create An Account",
      step3: "Step 3: Create Your Profile",
      marketingOptIn:
        "Are you sure you are not interested in staying connected to this program’s travel trade team?",
      optIn: "Yes, I’m Interested",
      optOut: "Not Interested",
      step2Sub1: "Tell Us About Yourself",
      step2Sub2: "Tell Us About Your Business",
      privacyHead: "COMMUNICATIONS PREFERENCES",
      privacySub:
        "Check the boxes below to ensure you receive important communications from the supplier’s travel trade team (product updates and announcements, rewards, incentives, FAMs, etc.) and travel trade networking and sales support initiatives from TravPRO Mobile.",
      privacy:
        "We protect your privacy and never sell, misuse or betray your trust.",
      store: "Easily download this program at your app store:",
      powered: "POWERED BY",
      toastMessage: {
        forgotSuccess:
          "We have e-mailed your password reset link! You will be redirected to the login page in 10 seconds.",
        emailNotExisting: "The email address you entered doesn't exist.",
        magicLinkMessage: "Please wait, we are signing you in right now.",
        magicLinkError:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkError1:
          "We couldn't find a valid token, please login or request a new magic link. If this problem persists, please contact us at: info@travpromobile.com.",
        magicLinkError2:
          "We couldn't find your account in our database, please log in manually. You will be redirected in 10 seconds.",
        magicLinkSuccess:
          "Check your email at {email}. It has a magic link that'll sign you in.",
        magicLinkErrorWait:
          "Please wait 5 minutes in between magic link requests.",
        emailNotFoundError:
          "The email address you entered can’t be found in our records. Please check for misspellings or create an account.",
      },
      errors: {
        zipCodeNotFound: "ZipCode not found, try again",
        zipCodeOnlyNumbers: "ZipCode can only contain numbers",
        password: "Please enter a password",
        passwordNotMatching: "The passwords you entered do not match",
        passwordTooShort: "Password needs to be at least 8 characters",
        emailExists:
          "This email address already exists or is invalid. Please try with another email address or login to your account.",
        fillInAllFields: "Please fill in all the required fields",
        fillInEmail: "Please fill in your email.",
        emailNotExisting: "The email address you entered doesn't exist.",
      },
      fields: {
        forgotSubCopy: "Forgot your password & want to change it? ",
        forgotSubCopy2:
          "Want to bypass password entirely? We will send you an email with a magic link that will automatically log you into the program. ",
        city: "City",
        companyName: "Company Name",
        role: "Your Role",
        description: "Which best describes your company's business?",
        country: "Country",
        password: "Password",
        passwordRegister: "Choose Password (8 character minimum)",
        passwordConfirm: "Confirm Password",
        firstName: "First Name (Given)",
        lastName: "Last Name (Family)",
        agency: "Your Agency Name",
        title: "Your Role (Select One)",
        company: "Company Name",
        select: "Select an option below",
        state: "State",
        province: "Province/Region/State",
        zipCode: "Zip Code",
        postalCode: "Postal Code",
        affiliate: "Which group is your MAIN agency affiliation?",
        hostAgency: "Your Host Agency?",
        executive: "Executive",
        management: "Management",
        marketing: "Marketing",
        sales: "Sales",
        coordinator: "Coordinator",
        opt: "Stay connected to this program's travel trade team and receive updates.",
        optMarketing:
          "Stay connected to TravPRO regarding similar programs and events.",
        retail: "Retail Store Front",
        home: "Home-Based Agent",
        independent: "Independent Contractor",
        host: "Host Agency",
        call: "Call Center or Web-Based Agency",
        other: "Other ",
        describes: "What best describes you and your agency’s business? ",
      },
    },
    title: "Travel Professional Training and Sales Enablement Program", // Product specific (TravPRO text or ChannelPRO text)
    welcome: {
      headerTop: "Welcome to",
      headerBottom: "Orlando Travel Academy", // Product specific
    },
    sellingPoints: {
      // All selling points can be product specific
      0: "Earn 2 Travel Institute CEU Credits",
      1: "Five (5) Foundation Chapters to Earn Diploma",
      2: "Partner Directory and Consumer Showcases",
      3: "Ready-To-Go Marketing Collateral",
      4: "Integrated High-impact Sales Resources",
      5: "Insider Tips & Promotions",
      6: "Timely News & Updates",
    },
    emailPrompt:
      "Please enter your email address and password to confirm that you are a travel professional.", // Product specific (TravPRO or ChannelPRO text)
    tAndC: {
      agree: "By continuing you agree with our ",
      privacyPolicy: "privacy policy",
      and: " and ",
      termsConditions: "terms and conditions",
    },
    fields: {
      agency: "Agency",
      email: "Email",
      password: "Password",
      passwordConfirm: "Confirm your password *",
      firstName: "First name *",
      lastName: "Last name *",
      city: "City *",
      agencyName: "Agency Name *",
      stateProvince: "State / Province *",
      required: "Required",
      invalidEmail: "Invalid email address",
      opt: "Stay In Touch! Yes, I'd like to opt in to communications from Orlando Travel Academy that will keep me posted on news, events, incentives, FAM’s and more!",
      complete: "Step 2: Complete your profile",
      tell: "Tell Us About Yourself",
      title: "Business Title *",
      host: "Host Agency Name",
      country: "Country / Region",
      select: "Please select an option below",
      header2: "Which segment(s) do you primarily sell?",
      step2: "Describe Your Business",
      leisure: "Leisure",
      corporate: "Corporate",
      group: "Group",
      affiliate: "What is Your Main Affiliation?",
      forgot:
        "Forgot your password? Click the button below and we’ll send you an email to reset your password.",
    },
    forgot: "Reset Password",
    noAgent: {
      noAgentButton: "I'm not an advisor",
      title: "Thank you for your interest in the Orlando Travel Academy.", // Product specific
      messageWeb:
        "The content on this site is exclusively for travel professionals. \n To learn more about Orlando, please visit: ", // Product specific
      messageMobile:
        "Some content on this app is exclusively for travel professionals, but feel free to browse a preview of what this app has to offer by pressing 'Continue'.", // Product specific
      continue: "Continue",
      visitWebsite: "Visit website",
    },
    newUser: "New User",
    register: "Register",
    registered: "This email is already registered",
    header:
      "Please take a moment to complete all the information below, as this is what will populate your profile and contact information.",
    step1: "Step 1: Complete your email address and choose a password.",
  },
  welcomeScreen: {
    title: "Welcome to the\nOrlando Travel Academy", // Product specific
    helloUser: "Hello {{name}}",
    hello: "Hello,",
    fromAgency: "from {{agency}}",
    notUser: "Not {{name}}?",
    introOnline:
      "Train immediately online or preload the content so it's always available for offline use!",
    introOffline:
      "You already have the latest version preloaded. Start training or selling anytime, anywhere!",
    startTraining: "Start learning",
    continueTraining: "Continue learning",
    graduated: "Congratulations!",
    downloader: {
      preload: "Preload",
      stop: "stop",
      init: "Initializing...",
      lastUpdate: "Last update: ",
    },
  },
  trainingScreens: {
    start: "Start",
    continue: "Continue",
    review: "Review",
    restart: "Restart",
    durationInMinutes: "{number} minutes",
    percentageComplete: "{number}% Complete",
    unlock: "Unlock this chapter by completing training chapter {number}.",
    unlockSubtitle: "Unlock more chapters by completing training chapters.",
    allUnlocked: "You have unlocked all chapters!",
    certificate: "Certificate",
    courseComplete: "Continue",
    endReached: "You've reached the end",
    retainEnd:
      "Use the top bar to navigate around in this chapter or press the back button to return to the overview.",
    watchListenRead: "Watch, Listen & Read more",
    trouble:
      "It looks like you're having trouble, please re-read the content on the previous page(s) and try again.",
    confirm: "Confirm your answer",
    choose: "Please choose an answer",
    skip: "Return >",
    viewAllTitle: "Training Tip",
    viewAll:
      "In order to proceed to the next page, please click on the icons to view the supplementary content. Videos, maps and other helpful information have been provided to enhance your training and ensure you achieve PRO status.",
    fillBlanks: "Fill in the blank(s):",
    next: "Next question",
    retry: "Try Again",
    fastTrackText: {
      success:
        "Congratulations, you've passed the Fast Track course and unlocked the rest of the training!",
      failed:
        "Unfortunately you didn't pass the Fast Track course, you can resume your training to earn your diploma!",
    },
    fastTrack: "Become a Swiss Travel Superstar!",
    fastTrackExplanation:
      'Simply take the quiz on the following pages for your chance to win a FAM to Switzerland!<br><br><span style="font-weight: bold">You will find all answers to the quiz questions in the following ways:</span><br><br>1.	The content that you learned in the Rail Europe and Switzerland modules<br><br>2.	And on the following websites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Be sure to review these resources in detail before taking the quiz! Only those with the highest of scores will have the chance to be invited to the FAM.</span>',
    fastTrackButton: "Click Here to Take the Swiss Superstar Quiz",
    grading: "Your final grade is: {grade}%",
  },
  nav: {
    home: "Home",
    train: "Learn",
    learn: "Learn",
    retain: "Retain",
    directory: "Directory",
    showRoom: "Showcases",
    showcases: "Showcases",
    offers: "Offers",
    promote: "Promote",
    sell: "Sell",
    info: "Info",
    rewards: "Rewards",
    media: "Media",
    favorites: "Favorites",
    contact: "Contact",
    reportCard: "View Diploma",
    accountSettings: "Account Settings",
    messages: "Messages",
    search: "Search",
  },
  contentHeaders: {
    specializations: "Specializations",
    train: "Learn",
    retain: "Retain",
    subapps: "Orlando Partner Modules",
    maintrainings: "The Foundation",
    subtrainings: "The Experience",
  },
  pageDescriptions: {
    specializations:
      "Take your Orlando Expert status to the next level by completing these chapters to earn specialization badges",
    train: "Educate, engage and become the expert.",
    showroom: "",
    retain:
      "Congratulations on completing your training! You have now unlocked your go-to resource for retaining your expert knowledge and enabling your sales efforts. Use this area to expertly answer a product question or even as an impromptu sales presentation — anytime, anywhere and from any device.",
    promote:
      "Share these items to ignite interest and start a conversation with clients and prospects.",
    sell: "Answer client questions and close the sale like a pro with deep resources and targeted sales support.",
    favorites: "Check out your personally favorited content",
    search: "Look through all content",
    subapps: "",
    maintrainings:
      "Start with the basics about Orlando and where your clients can stay.",
    subtrainings:
      "Complete these modules about all the amazing things clients can do and see in Orlando and receive your certificate as an official Orlando Expert.",
  },
  general: {
    offerBig:
      "With your expert status comes many benefits, starting with exclusive offers and discounts available just for you! Click on the Offers button on the home page to start reaping the rewards of your efforts.",
    badge: "View<br>Badge",
    offerMessage: "LEGOLAND Florida Free Ticket Offer",
    next: "Next",
    yes: "Yes",
    no: "No",
    previous: "Previous",
    submit: "Submit",
    back: "Back",
    close: "Close",
    page: "Page",
    search: "Search",
    logIn: "Log in",
    logOut: "Log Out",
    viewItem: "View {type}",
    imageNotFound: "Image not found",
    noResultsFor: "No results have been found for: {{query}}",
    noFavorites: "You don't have any favorites yet.",
    noMessages: "You haven't received any messages yet!",
    resultsFor: "Results for: {{query}}",
    showAll: "Show all",
    connectionError: "Connection error",
    alreadyExists: "Already exists",
    pageNotFound: "404 Page Not Found!",
    oops: "Uh oh...",
    overview: "Return to overview",
    complete: "Continue",
    courseComplete: "Chapter Complete!",
    chapterComplete: "Chapter Completed!",
    message: "{count} Message",
    messagePlural: "{count} Messages",
    unlock: "Unlock this item by completing the Learn section.",
    completion: "Complete Foundation to unlock this item.",
  },
  itemTypes: {
    image: "Image",
    brochure: "Collection",
    layout: "Layout",
    web: "Website",
    pdf: "PDF",
    carousel: "Collection",
  },
  questions: {
    dials: "Rotate the dials to match the answer",
    fitb: "Fill in the blank(s)",
    flip: "Change the number to match the answer",
    multipleChoice: "Pick the right answer(s)",
    slider: "Pick the right answer using the slider",
    map: "Answer the question by tapping the right location on the map",
    dropdown: "Choose...",
    true: "True",
    false: "False",
  },
  reportCard: {
    download: "Download",
    email: "Email",
    print: "Print",
  },
  cookies: {
    consent: "AGREE",
    optout: "Opt-out",
    settings: "Privacy Settings",
    message:
      "You haven't told us anything about your data privacy preferences! That's ok, but we'd like to offer you the best experience using the Sales Companion.",
    disabled: "It looks like you have disabled the use of cookies.",
    use: "The {{appName}} requires the use of cookies to deliver you the best experience.",
    details: "What are the cookies used for?",
    enable: "See how to enable your cookies {{here}}.",
    here: "here",
  },
  notLoggedIn: {
    super: "You're not logged in",
    title: "You need to be logged in to view this content",
    guest: "Guest",
  },
  demo: {
    message:
      "This website is a demo of the final product. It is currently in-development and not a complete product.",
    consent: "Understood!",
  },
  share: {
    header: "Share this resource on your favorite social media!",
    download: "Download",
  },
  sharing: {
    copyURL: "Copy Link",
    copied: "Copied",
  },
  breadCrumbs: {
    page: "Page",
  },
  contact: {
    vp: "Vice President of Travel Industry Sales",
    na: "Travel Industry Sales Director, North America",
    emea: "Travel Industry Sales Director, EMEA",
    la: "Travel Industry Sales Director, Latin America",
  },
  onMobile: {
    header:
      "It looks like you're trying to access the {appName} app from a mobile device",
    body: "To download this program simply visit your app store and search for {appName} or click one of the buttons below",
    benefits: {
      header: "This will provide you with:",
      1: "Learn, Promote & Sell on the Go",
      2: "Multi-media Training Across Devices",
      3: "Certificate of Completion",
      4: "Ready-made Sales Presentations",
      5: "High-impact Promotional Materials",
      6: "Real-time Product Directory",
      7: "Timely News & Updates",
    },
  },
  directory: {
    attractions: "Attractions",
    hotels: "Hotels",
    dining: "Dining",
    nightlife: "Nightlife",
    artsculturehistory: "Arts, Culture & History",
    themeparks: "Theme Parks",
    sportsrecreationoutdoors: "Sports, Recreation & Outdoors",
    otheraccommodations: "Other Accommodations",
    shopping: "Shopping",
    weddingservices: "Wedding Services",
    medicalservices: "Medical Services",
    golf: "Golf",
    transportationservices: "Transportation Services",
    spas: "Spas",
    filters: "Filters",
    reset: "Reset Filters",
    view: "View Now",
    amount: "Amount of Results",
    retail: "Retail",
    accommodations: "Accommodations",
    transportation: "Transportation",
    conventionservices: "Convention Services",
    visitorprofessionalservices: "Visitor & Professional Services",
    visitoranddownloadprofessionalservices: "Visitor & Professional Services",
    studentandyouthgroupfriendly: "Student & Youth Group Friendly",
  },
  custom: {
    splitUsers: "I Am A ...",
    brandAmbassador: "Brand Ambassador",
    travelPro: "Travel Professional",
  },
};
